import { render, staticRenderFns } from "./ListNameForm.vue?vue&type=template&id=5be372aa&scoped=true&"
import script from "./ListNameForm.vue?vue&type=script&lang=js&"
export * from "./ListNameForm.vue?vue&type=script&lang=js&"
import style0 from "./ListNameForm.vue?vue&type=style&index=0&id=5be372aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be372aa",
  null
  
)

export default component.exports